import { useState } from "react";
import {
  Box,
  Input,
  Button,
  VStack,
  useToast,
  HStack,
  Textarea,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Text,
} from "@chakra-ui/react";
import axios from "axios";

const BASE_URL = "https://develop-project-360.onrender.com";

export const createStage = (data) =>
  axios.post(`${BASE_URL}/createStage`, data);

const StageForm = ({ projectId, onStageCreated }) => {
  const [name, setName] = useState("");
  const [order, setOrder] = useState(0);
  const [description, setDescription] = useState("");

  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const resetForm = () => {
    setName("");
    setOrder(0);
    setDescription("");
    setShowDetailsForm(false);
  };

  const handleInitialSubmit = () => {
    if (!name.trim()) {
      toast({ title: "Phase name is required", status: "warning" });
      return;
    }
    onOpen();
  };

  const handleFinalSubmit = async () => {
    try {
      const payload = {
        name,
        projectId,
        order,
        description,
      };
      const { data } = await createStage(payload);
      toast({
        title: "Phase created & team members or team leads",
        status: "success",
      });
      onStageCreated(data.data);
      resetForm();
      onClose();
    } catch {
      toast({ title: "Error creating phase", status: "error" });
    }
  };

  return (
    <Box p={1} borderWidth="1px" rounded="md">
      <VStack spacing={2} align="stretch">
        {!showDetailsForm && (
          <HStack spacing={3}>
            <Input
              placeholder="Phase Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <Button
              onClick={handleInitialSubmit}
              bgGradient="linear(to-r, green.300,  teal.100)"
              _hover={{ bgGradient: "linear(to-r, green.100,  green.400)" }}
              size={"sm"}
            >
              Create Phase
            </Button>
          </HStack>
        )}

        {/* Modal Confirmation */}
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Add more details?</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text>
                Would you like to add a description and custom order to this
                phase before submitting?
              </Text>
            </ModalBody>
            <ModalFooter>
              <Button
                variant="ghost"
                mr={3}
                onClick={() => {
                  setShowDetailsForm(true);
                  onClose();
                }}
              >
                Yes
              </Button>
              <Button
                bgGradient="linear(to-r, green.300, teal.100)"
                _hover={{ bgGradient: "linear(to-r, green.100, green.400)" }}
                onClick={handleFinalSubmit}
              >
                No, Submit Now
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Detailed Form */}
        {showDetailsForm && (
          <Box borderWidth="1px" borderRadius="md" p={4}>
            <VStack spacing={4}>
              <FormControl>
                <FormLabel>Phase Name</FormLabel>
                <Input value={name} onChange={(e) => setName(e.target.value)} />
              </FormControl>

              <FormControl>
                <FormLabel>Description</FormLabel>
                <Textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Phase Description"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Order</FormLabel>
                <Input
                  type="number"
                  value={order}
                  onChange={(e) => setOrder(Number(e.target.value))}
                  placeholder="Optional phase order"
                />
              </FormControl>

              <Button
                onClick={handleFinalSubmit}
                width="full"
                bgGradient="linear(to-r, green.300, teal.100)"
                _hover={{ bgGradient: "linear(to-r, green.100, green.400)" }}
              >
                Submit Phase
              </Button>
            </VStack>
          </Box>
        )}
      </VStack>
    </Box>
  );
};

export default StageForm;
